(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sbs-audio-player"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sbs-variant-audio')) return;
    let audio = null;
    let activeHost = null;
    let activeVariant = null;

    const sync = () => document.querySelectorAll('sbs-variant-audio').forEach(host => host.sync?.());
    const stop = () => {
      const previous = audio;
      audio = null;
      activeHost = null;
      activeVariant = null;
      if (previous) {
        previous.pause();
        previous.remove();
      }
      sync();
    };
    const play = (host, entry) => {
      if (!entry?.dataset.sound) { stop(); return; }
      if (activeHost === host && activeVariant === entry.dataset.sbsVariant && audio) {
        if (audio.paused) audio.play().catch(() => { stop(); });
        else audio.pause();
        sync();
        return;
      }
      stop();
      const current = new Audio(entry.dataset.sound);
      audio = current;
      activeHost = host;
      activeVariant = entry.dataset.sbsVariant;
      current.hidden = true;
      current.dataset.sbsPlayback = entry.dataset.sbsVariant;
      host.append(current);
      ['timeupdate', 'loadedmetadata', 'play', 'pause'].forEach(name => current.addEventListener(name, () => { if (audio === current) host.updateTimeline(); }));
      host.querySelector('[data-sbs-audio-status]').textContent = '';
      current.addEventListener('ended', () => { if (audio === current) stop(); }, { once: true });
      current.addEventListener('error', () => {
        if (audio !== current) return;
        stop();
        host.querySelector('[data-sbs-audio-status]').textContent = host.dataset.error;
      }, { once: true });
      sync();
      current.play().catch(() => {
        if (audio !== current) return;
        stop();
        host.querySelector('[data-sbs-audio-status]').textContent = host.dataset.error;
      });
    };

    class VariantAudio extends HTMLElement {
      connectedCallback() {
        this.entries = [...this.querySelectorAll('[data-sbs-variant]')];
        this.recordings = this.entries.filter(entry => entry.dataset.sound);
        if (this.dataset.compact === 'true' && !this.swipeBound) {
          this.swipeBound = true;
          this.addEventListener('pointerdown', event => {
            if (!event.target.closest('[data-sbs-carousel]') || event.pointerType === 'mouse') return;
            this.swipeStart = { x: event.clientX, y: event.clientY };
          });
          this.addEventListener('pointercancel', () => { this.swipeStart = null; });
          this.addEventListener('pointerup', event => {
            if (!this.swipeStart) return;
            const dx = event.clientX - this.swipeStart.x;
            const dy = event.clientY - this.swipeStart.y;
            this.swipeStart = null;
            if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
              this.suppressClickUntil = Date.now() + 450;
              this.step(dx < 0 ? 1 : -1);
            }
          });
          this.addEventListener('click', event => {
            if (Date.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); }
          }, true);
        }
        this.root = this.dataset.compact === 'true' ? this : this.closest('product-information') || this.parentElement;
        this.enhance();
        this.observer = new MutationObserver(records => { if (records.some(record => !record.target.closest?.('.sbs-audio-panel'))) this.enhance(); });
        this.observer.observe(this.root, { childList: true, subtree: true });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (activeHost === this) stop();
      }
      step(direction) {
        if (this.recordings.length < 2) return;
        const button = this.querySelector('[data-sbs-sample]');
        const index = this.recordings.findIndex(entry => entry.dataset.sbsVariant === button.dataset.sbsSample);
        if (activeHost === this) stop();
        const entry = this.recordings[(index + direction + this.recordings.length) % this.recordings.length];
        button.dataset.sbsSample = entry.dataset.sbsVariant;
        this.querySelector('[data-sbs-sample-label]').textContent = entry.dataset.title.replace(/\s*-\s*/g, '–');
        this.querySelector('[data-sbs-audio-status]').textContent = entry.dataset.title;
        this.sync();
      }
      enhance() {
        let integrated = false;
        if (this.dataset.productRecordings !== 'true' && this.dataset.compact !== 'true' && this.dataset.optionCount === '1') {
          this.root.querySelectorAll('variant-selects input[type="radio"]').forEach(input => {
            const entry = this.entries.find(item => JSON.parse(item.dataset.options)[0] === input.value);
            if (!entry?.dataset.sound) return;
            const label = this.root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
            if (!label) return;
            integrated = true;
            input.dataset.sbsSoundVariant = entry.dataset.sbsVariant;
            label.classList.add('sbs-audio-ready');
            const sizeText = label.querySelector('.single-option-selector__option__text');
            const compactSize = input.value.replace(/\s*-\s*/g, '–');
            if (sizeText && sizeText.textContent.trim() !== compactSize) sizeText.textContent = compactSize;
            input.closest('.single-option-selector--box')?.classList.add('sbs-size-row');
            if (!label.querySelector('.sbs-audio-chip')) label.append(this.querySelector('.sbs-audio-chip').cloneNode(true));
          });
        }
        this.querySelector('[data-sbs-sample]').hidden = integrated;
        this.sync();
      }
      sync() {
        if (!this.root) return;
        this.root.querySelectorAll('input[data-sbs-sound-variant]').forEach(input => {
          const playing = activeHost === this && input.dataset.sbsSoundVariant === activeVariant && audio && !audio.paused;
          const label = this.root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          label?.classList.toggle('sbs-audio-playing', playing);
          input.setAttribute('aria-label', `${input.value}: ${playing ? this.dataset.pause : this.dataset.play}`);
        });
        this.querySelectorAll('[data-sbs-sample]').forEach(button => {
        const playing = Boolean(activeHost === this && button.dataset.sbsSample === activeVariant && audio && !audio.paused);
        button.classList.toggle('sbs-audio-playing', playing);
        button.setAttribute('aria-pressed', String(playing));
        const newAction = playing ? this.dataset.pause : this.dataset.play;
        const currentEntry = this.entries.find(entry => entry.dataset.sbsVariant === button.dataset.sbsSample);
        button.setAttribute('aria-label', `${newAction}: ${this.dataset.productTitle}, ${currentEntry?.dataset.title || ''}`);
        });
        this.updateTimeline();
      }
      updateTimeline() {
        const progress = this.querySelector('[data-sbs-card-progress]');
        if (progress) {
          const current = activeHost === this ? audio : null;
          progress.hidden = !current;
          progress.style.setProperty('--sbs-progress', current && Number.isFinite(current.duration) && current.duration > 0 ? current.currentTime / current.duration : 0);
        }
        const timeline = this.querySelector('.sbs-audio-timeline');
        if (!timeline) return;
        const current = activeHost === this ? audio : null;
        timeline.hidden = !current;
        this.querySelector('.sbs-audio-panel').hidden = !current;
        if (!current) return;
        const duration = Number.isFinite(current.duration) ? current.duration : 0;
        const format = value => `${Math.floor(value / 60)}:${String(Math.floor(value % 60)).padStart(2, '0')}`;
        const time = this.querySelector('[data-sbs-time]');
        const text = `${format(current.currentTime)} / ${format(duration)}`;
        if (time.textContent !== text) time.textContent = text;
        this.querySelector('[data-sbs-seek]').value = duration ? current.currentTime / duration * 100 : 0;
        const toggle = this.querySelector('[data-sbs-toggle]');
        if (!toggle.firstElementChild) toggle.append(this.querySelector('.sbs-audio-chip').cloneNode(true));
        toggle.classList.toggle('sbs-audio-playing', !current.paused);
        toggle.setAttribute('aria-label', current.paused ? this.dataset.play : this.dataset.pause);
      }
    }

    customElements.define('sbs-variant-audio', VariantAudio);
    document.addEventListener('click', event => {
      const arrow = event.target.closest('[data-sbs-step]');
      if (arrow) { event.preventDefault(); arrow.closest('sbs-variant-audio').step(Number(arrow.dataset.sbsStep)); return; }
      const toggle = event.target.closest('[data-sbs-toggle]');
      if (toggle && activeHost === toggle.closest('sbs-variant-audio')) {
        play(activeHost, activeHost.entries.find(entry => entry.dataset.sbsVariant === activeVariant));
        return;
      }
      const button = event.target.closest('[data-sbs-sample]');
      if (button) {
        const host = button.closest('sbs-variant-audio');
        play(host, host.entries.find(entry => entry.dataset.sbsVariant === button.dataset.sbsSample));
        return;
      }
      const input = event.target.closest('variant-selects input[type="radio"]');
      if (!input) return;
      const root = input.closest('product-information');
      const host = root?.querySelector('sbs-variant-audio[data-compact="false"]');
      if (host) play(host, host.entries.find(entry => entry.dataset.sbsVariant === input.dataset.sbsSoundVariant));
    });
    document.addEventListener('input', event => {
      if (!event.target.matches('[data-sbs-seek]') || activeHost !== event.target.closest('sbs-variant-audio') || !Number.isFinite(audio?.duration)) return;
      audio.currentTime = Number(event.target.value) / 100 * audio.duration;
      activeHost.updateTimeline();
    });
    document.addEventListener('change', event => {
      const select = event.target.closest('variant-selects select');
      if (!select) return;
      const host = select.closest('product-information')?.querySelector('sbs-variant-audio');
      if (!host) return;
      const values = [...select.closest('variant-selects').querySelectorAll('select')].map(item => item.value);
      const entry = host.entries.find(item => JSON.stringify(JSON.parse(item.dataset.options)) === JSON.stringify(values));
      const button = host.querySelector('[data-sbs-sample]');
      button.disabled = !entry?.dataset.sound;
      if (entry) {
        button.dataset.sbsSample = entry.dataset.sbsVariant;
        const label = button.querySelector('[data-sbs-sample-label]');
        if (label) label.textContent = entry.dataset.title;
      }
      play(host, entry);
    });
    window.addEventListener('pagehide', stop);
  })();
  } catch(e) { console.error(e); }
})();

})();
